import { sql } from '@w/db'
import { s } from '@w/schema'
import { queryOptions } from '@w/react-query/db'
import type { WorkspaceDb } from '../db/workspace-tables'

const duplicateReviewSchema = s.object({ qid:s.string(),stageAt:s.number(),deviceId:s.string(),occurredAt:s.number(),eventId:s.string() })
/** History only: every event in a repeated owner/question/stage group, including same-device repeats. */
export function duplicateStageReviewsOptions(db:WorkspaceDb,userId:string,qid?:string) {
  return queryOptions(db.query`SELECT qid,stageAt,deviceId,occurredAt,id AS eventId FROM ${db.flashcardEvents} e
    WHERE e.userId=${userId} AND (${qid ?? sql`NULL`} IS NULL OR e.qid=${qid ?? sql`NULL`})
      AND (SELECT count(*) FROM ${db.flashcardEvents} other
        WHERE other.userId=e.userId AND other.qid=e.qid AND other.stageAt=e.stageAt)>1
    ORDER BY qid,stageAt,occurredAt,id`,duplicateReviewSchema)
}
export function readDuplicateStageReviews(db:WorkspaceDb,userId:string,qid:string) {
  return duplicateStageReviewsOptions(db,userId,qid).queryFn()
}
